<template>
  <ViewWrapper class="global_countdown">
    <Countdown
      #default="{ indicatorPercentage, skipCountdown }"
      @countdownFinished="$router.replace({ name: 'questions' })"
    >
      <section class="global_countdown__inner" @click="skipCountdown">
        <!-- TODO: move ProgressFrameBar in page wrapper component and wait for animationend event until it dissappears -->
        <ProgressFrameBar :indicator-percentage="indicatorPercentage" />

        <i18n
          tag="h2"
          class="global_countdown__info"
          path="view.globalShockCountdown.headline.value"
        >
          <template #decisions>
            <br />
            <b class="typo_hl">{{ $t('view.globalShockCountdown.headline.decisions') }}</b>
            <br />
          </template>
        </i18n>
      </section>
    </Countdown>
  </ViewWrapper>
</template>
<script>
import Countdown from '../components/Countdown';
import ProgressFrameBar from '../components/ProgressFrameBar';
import ViewWrapper from '../components/ViewWrapper';
import { playSound } from '../services/sound';

export default {
  name: 'GlobalShockCountdown',

  components: {
    Countdown,
    ProgressFrameBar,
    ViewWrapper,
  },
  mounted() {
    playSound('fxA', 'headline');
  },
};
</script>

<style lang="scss" scoped>
.global_countdown {
  background-color: rgba($color-black, $view-overlay-alpha);
}

.global_countdown__inner {
  display: flex;
  align-items: center;
  justify-content: center;
}

.global_countdown__info {
  @include module-headline;
  text-align: center;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 80%;
}
</style>
